module.exports = "/images/vendor/jquery-ui-dist/ui-icons_777777_256x240.png?40bf25799e4fec8079c7775083de09df";